import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "antd";
import {
  FiEdit,
  FiPlus,
  FiSearch,
  FiTrash2,
  FiUser,
  FiFileText,
  FiDownload,
} from "react-icons/fi";

import { TableContextProvider } from "./../../store/table-context";
import {
  confirm,
  modalError,
  modalSuccess,
} from "../../services/notifications";
import {
  actions,
  getToken,
  hasPermission,
  hasPermissionRestrict,
  hasRestrictContent,
} from "../../services/security";

import Card from "./../../Components/ui/card";
import Header from "../../Components/ui/header";
import Filters from "../../Components/ui/filters";
import Table from "../../Components/ui/table";
import { BASEURL } from "../../services/url";
import http from "../../services/http";
import { Context } from "../../store/masterDoc-context";

const PlantillaPage = () => {
  let navigate = useNavigate();

  const title = "Plantilla";
  const icon = <FiFileText />;
  const breadcrumb = [{ title: "Plantilla", url: "/plantillas" }];
  // const [codigosMasterDoc, setCodigosMasterDoc] = useState([]);
  const [state, setState] = useContext(Context);

  const [filters, setFilters] = useState([
    {
      type: "select",
      label: "Nombre Documento",
      name: "descripcionMasterDoc",
      values: [],
      // changeBool: true,
    },
    // {
    //   type: "select",
    //   label: "Nombre documento",
    //   name: "descripcionMasterDoc",
    //   values: [],
    // },
    {
      type: "input",
      label: "Versión (Ingrese n° de versión)",
      name: "version",
      hidden: hasPermission(actions.PLantillasMasterDocUltimaVersionVer),
    },
  ]);

  const columns = [
    { title: "Código Documento", property: "codMasterDoc", sortable: true },
    {
      title: "Nombre Documento",
      property: "descripcionMasterDoc",
      sortable: true,
    },
    { title: "Fecha", property: "fechaCreacion", sortable: true },
    { title: "Version", property: "version", sortable: true },
  ];

  const menuSearch = [
    {
      key: "1",
      icon: <FiSearch />,
      label: "Ver / Editar",
    },
  ];

  const menuEdit = [
    {
      key: "1",
      icon: <FiEdit />,
      label: "Editar",
    },
  ];

  const menuDelete = [
    {
      key: "2",
      icon: <FiTrash2 />,
      label: "Eliminar",
    },
  ];

  const menuPDF = [
    {
      key: "3",
      icon: <FiDownload />,
      label: "PDF",
    },
  ];

  const menuDOCX = [
    {
      key: "4",
      icon: <FiDownload />,
      label: "DOCX",
    },
  ];


  useEffect(() => {
    async function getData() {
      const response = await http.get(
        `${BASEURL}/PlantillaMasterDoc/CodMasterDoc`
      );
      if (response) {
        const data = response.data;
        // setCodigosMasterDoc(data);
        let dataFilter = data.map((item, index) => {
          return {
            key: index,
            value: item.descripcionMasterDoc,
            text: item.descripcionMasterDoc,
          };
        });

        setFilters((prevState) => {
          return prevState.map((item) => {
            if (item.name === "descripcionMasterDoc") {
              return { ...item, values: dataFilter };
            }
            return item;
          });
        });
      }
    }
    getData();
  }, []);

  const menu = (item) => (
    <div>
      {(hasRestrictContent()
        ? hasPermissionRestrict(actions.RestriccionVer, item.codMasterDoc) &&
          !hasPermission(actions.PlantillaMasterDocInfoReducidaVer)
        : hasPermission(actions.PlantillaMasterDocEditar) &&
          !hasPermission(actions.PlantillaMasterDocInfoReducidaVer)) && (
        <Menu items={menuSearch} onClick={() => onClickEdit(item)} />
      )}

      {(hasRestrictContent()
        ? hasPermissionRestrict(actions.RestriccionEliminar, item.codMasterDoc)
        : hasPermission(actions.PlantillaMasterDocEliminar)) && (
        <Menu items={menuDelete} onClick={() => onClickDelete(item)} />
      )}

      {<Menu items={menuPDF} onClick={() => onClickPDF(item)} />}

      {<Menu items={menuDOCX} onClick={() => onClickDOCX(item)} />}
    </div>
  );

  const onClickAdd = () => {
    navigate("/plantillas/nuevo");
  };

  const onClickEdit = (item) => {
    setState({ ...state, codMaster: item.codMasterDoc });
    navigate(`/plantillas/${item.id}`);
  };

  const onClickDelete = async (item) => {
    const confirmed = await confirm(
      "Eliminar plantilla",
      `¿Esta seguro que desea eliminar la plantilla ${item.descripcionMasterDoc}?`
    );

    if (!confirmed) {
      return;
    }

    const response = await http
      .delete(`${BASEURL}/PlantillaMasterDoc/${item.id}`)
      .catch((error) => {
        if (error.response) {
          modalError(
            error.response.data.errores[0].titulo,
            error.response.data.errores[0].detalle
          );
        }
      });
    if (response) {
      await modalSuccess(
        "Plantilla eliminada",
        "La plantilla fue eliminada exitosamente"
      );
      navigate(0);
    }
  };

  const onClickPDF = async (item) => {
    const response = await http
      .get(`${BASEURL}/PlantillaMasterDoc/Pdf/${item.id}`)
      .catch((error) => {
        if (error.response) {
          modalError(
            error.response.data.errores[0].titulo,
            error.response.data.errores[0].detalle
          );
        }
      });
    if (response) {
      const byteString = window.atob(response.data.plantillaB64);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      // window.open(url);

      const fileName = response.data.nombreArchivo;
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName;
      a.target = "_blank";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  };

  const onClickDOCX = async (item) => {
    const response = await http
      .get(`${BASEURL}/PlantillaMasterDoc/Docx/${item.id}`)
      .catch((error) => {
        if (error.response) {
          modalError("Error", "No se pudo descargar el archivo");
        }
      });

    if (response) {
      const byteString = window.atob(response.data.plantillaB64);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([ab], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      // Obtener el nombre de archivo de response.data.nombreArchivo
      const fileName = response.data.nombreArchivo;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  };

  // const handleCodMasterDocSelect = (selectedValue) => {
  //   // Buscar el masterTramite correspondiente al selectedValue en codigosMasterDoc
  //   if (selectedValue !== undefined) {
  //     const selectedMasterTramite = codigosMasterDoc.find(
  //       (item) => item.codMasterDoc === selectedValue
  //     );
  //     if (selectedMasterTramite) {
  //       // Realiza las operaciones que necesites con selectedMasterTramite
  //       let prueba = selectedMasterTramite.map((item, index) => {
  //         return {
  //           key: index,
  //           value: item.descripcionMasterDoc,
  //           text: item.descripcionMasterDoc,
  //           disabled: item.codMasterDocVacio,
  //         };
  //       });
  //       setFilters((prevState) => {
  //         return prevState.map((item) => {
  //           if (item.name === "descripcionMasterDoc") {
  //             return { ...item, values: prueba };
  //           }
  //           return item;
  //         });
  //       });
  //     }
  //   } else {
  //     setFilters((prevState) => {
  //       return prevState.map((item) => {
  //         if (item.name === "descripcionMasterDoc") {
  //           return { ...item, values: [] };
  //         }
  //         return item;
  //       });
  //     });
  //   }
  // };

  const buttons = [
    {
      title: "Agregar Plantilla ",
      text: <FiPlus />,
      type: "primary",
      onClick: onClickAdd,
      visible: hasPermission(actions.PlantillaMasterDocCrear),
    },
  ];

  return (
    <TableContextProvider>
      <Card>
        <Header
          title={title}
          icon={icon}
          breadcrumb={breadcrumb}
          showFilters
          buttons={buttons}
        />
        <Filters
          // onCodMasterDocSelect={handleCodMasterDocSelect}
          fields={filters}
        />
        <Table
          id="table-plantillas"
          columns={columns}
          menu={menu}
          url="/PlantillaMasterDoc"
          orderBy="nombre"
          orderDirection="ascending"
        />
      </Card>
    </TableContextProvider>
  );
};

export default PlantillaPage;
